import React, { useState } from "react";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

/**
 *
 * @param {*} report Structure that influence the graphic of table (in the end of this file 2 example of structure)
 * @param {*} goToDetails Function called if user press arrow-right in the end of the row passing the informations of the row
 * @returns Table component rendered
 */
const ReportCommonTable = ({ className, report, goToDetails }) => {
  const [visibilityRow, setVisibilityRow] = useState(null);

  const openRow = index => {
    let tmp = { ...visibilityRow };
    tmp[index] = !tmp[index];
    setVisibilityRow(tmp);
  };

  const buildRows = (keys, rows) => {
    let tmpVisibility = {};
    let parentIndex = -1;
    const rowsTable = rows.map((r, indexR) => {
      // Start mapping to create the rows
      // Set visibility for table with dropdown
      if (r["subRow"]) tmpVisibility[parentIndex] = false;
      else parentIndex = indexR; // Set parent if subrow
      return (
        <tr
          key={"roW_"+indexR}
          className={
            (r["subRow"] ? "child" : "") +
            (visibilityRow != null && visibilityRow[parentIndex]
              ? " visible"
              : "")
          }
        >
          {keys.map((k, index) => {
            // Start mapping to create the columns
            if (index === 0 && r["accordion"]) {
              // Add arrow in first column if it is an accordion
              const icon =
                visibilityRow && visibilityRow[indexR]
                  ? "angle-down"
                  : "angle-right";
              return (
                <td
                  key={index}
                  className="main"
                  onClick={() => openRow(indexR)}
                >
                  {r[k.id || k] && <FontAwesomeIcon icon={["far", icon]} />}
                  <span> {r[k.id || k]}</span>
                </td>
              );
            }
            return r[k.id || k] ? <td key={index}>{r[k.id || k]}</td> : <td key={index}></td>;
          })}

          {// Add external-link-square icon if present in the structure
            r["externalLinkSquare"] && (
              <td key={keys.lenght}>
                <FontAwesomeIcon
                  icon={["far", "external-link-square"]}
                  style={{
                    color: "#0090d1"
                  }}
                  onClick={() => {}}
                />
              </td>
            )}            
          {// Add arrow to go to details if hasDetails present for the row
            r["hasDetails"] && (
              <td key={keys.length}>
                <FontAwesomeIcon
                /** arrow-right è la freccia vapor complaint */
                  icon={["far", "arrow-right"]}
                  style={{
                    color: "#0090d1",
                    cursor: "pointer"
                  }}
                  onClick={goToDetails ? () => goToDetails(r) : {}}
                />
              </td>
            )}
        </tr>
      );
    });
    if (!visibilityRow) setVisibilityRow(tmpVisibility);
    return rowsTable;
  };

  return (
    <table className={"dbx-reports-table " + (className ? className : "")}>
      <thead>
        <tr>
          {report &&
            report.header &&
            report.header.map((h, index) => <th key={index}>{h.label || h}</th>)}
          <th></th>
        </tr>
      </thead>
      <tbody>{buildRows(report.header, report.rows)}</tbody>
    </table>
  );
};

ReportCommonTable.propTypes = {
  report: PropTypes.object.isRequired,
  goToDetails: PropTypes.func
};

ReportCommonTable.defaultProps = {
  goToDetails: null
};

export default ReportCommonTable;

/** Example of report we can pass
const report = {
    header: ["Descrizione", "Codice IVA", "Natura IVA", "Aliquota IVA", "Imponibile", "Imposta", "Totale"],
    rows: [
        {
            "Descrizione": "Vendite",
            "Imponibile": 3000,
            "Imposta": 3000,
            "Totale": 3000,
            "accordion": true
        },
        {
            "Descrizione": "Vendite nazionali",
            "subRow": true
        },
        {
            "Descrizione": "Totale",
            "Imponibile": 3000,
            "Imposta": 3000,
            "Totale": 3000,
            "codeAccount": "25/05/50",
            "subRow": true
        },
        {}
    ]
};
const details = {
    id: "25/05/50",
    header: ["Tipo documento", "Contabilizzato", "Tipo", "Numero del conto", "Data IVA", "Protocollo", "Testo", "Definitivo", "Codice IVA", "Importo", "Saldo"],
    rows: [
        { "Tipo documento": "Nome", "Contabilizzato": "Si", "Tipo": "Lorep ipsum", "Numero del conto": 6805192, "Data IVA": "08/04/21", "Protocollo": "FAC1", "Testo": "Fornitore1", "Codice IVA": "A022", "Importo": "1.000,00", "Saldo": "1.000,00", externalLinkSquare: true },
        { "Tipo documento": "Nome", "Contabilizzato": "Si", "Tipo": "Lorep ipsum", "Numero del conto": 6805192, "Data IVA": "08/04/21", "Protocollo": "FAC1", "Testo": "Fornitore1", "Codice IVA": "A022", "Importo": "1.000,00", "Saldo": "1.000,00", externalLinkSquare: true }
    ]
};
*/
